import { useEffect } from "react"

const useOutsideClick = ({ ref, enabled = true, onOutside }) => {

  useEffect(() => {
    const handleOutside = (e) => {
      if (!enabled) return
      if (!ref.current) return
      if (ref.current.contains(e.target)) return
      
      onOutside()
    }

    document.addEventListener("mousedown", handleOutside)

    return () => {
      document.removeEventListener("mousedown", handleOutside)
    }
  }, [ref, enabled, onOutside])
}

export default useOutsideClick